// eslint-disable-next-line no-use-before-define
import React from 'react';

import SkeletonMessage from './SkeletonMessage';

const ChannelListSkeleton = () => {
  return (
    <div>
      <SkeletonMessage />
      <SkeletonMessage />
      <SkeletonMessage />
      <SkeletonMessage />
      <SkeletonMessage />
    </div>
  );
};

export default ChannelListSkeleton;
